import { render } from "./VehicleNameDisplay.vue?vue&type=template&id=6db021c4&scoped=true"
import script from "./VehicleNameDisplay.vue?vue&type=script&lang=js"
export * from "./VehicleNameDisplay.vue?vue&type=script&lang=js"

import "./VehicleNameDisplay.vue?vue&type=style&index=0&id=6db021c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db021c4"]])

export default __exports__